module.exports = __webpack_public_path__ + "img/INVOICE.2796868b.svg";